import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useEffect, useState } from "react";
import {
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
} from "../../service/auth";
import { useAppDispatch } from "../../hooks/store";
import { showError, showToast } from "../../constants/toasts";
import { temporaryToken } from "../../reducers/authSlice";
import { OTP_FOR } from "../../constants/enums";

const OtpVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { email } = location.state || {};
  const dispatch = useAppDispatch();
  const [otp, setOtp] = useState("");
  const [countDown, setCountDown] = useState(30);

  const [verifyOtp, { isLoading }] = usePostVerifyOtpMutation();
  const [resendOtp] = useForgotPasswordMutation();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (otp.length !== 4) {
      showError("Please enter a valid 4-digit OTP");
      return;
    }

    try {
      const body = { email,  otp,otpType:OTP_FOR.FORGOT_PASSWORD };

      const res = await verifyOtp(body).unwrap();

      if (res?.code === 200) {
        dispatch(temporaryToken({ tempToken: res.data.token }));
        showToast("OTP Verified Successfully");

        navigate("/reset-password", {
          replace: true,
          state: {
            email,
            code: otp,
          },
        });
      }
    } catch (err: any) {
      showError(err?.data?.message || "OTP Verification Failed");
      setOtp("");
    }
  };

  const handleResendOtp = async () => {
    try {
      const body = { email, otpType: OTP_FOR.FORGOT_PASSWORD };
      const res = await resendOtp(body).unwrap();

      if (res?.code === 200) {
        showToast("OTP Resent Successfully");
        setCountDown(30);
      }
    } catch (err: any) {
      showError(err?.data?.message || "Failed to resend OTP");
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      const timer = setTimeout(() => setCountDown(countDown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify Email Address</h2>
        <p>
          A verification OTP has been sent to your email. Please check your
          inbox.
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <label htmlFor="otp">Enter OTP</label>
            <div className="opt_fields">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} id="otp" />}
                inputType="tel"
                shouldAutoFocus
              />
            </div>
            {/* <div className="auth_bottom">
              <p>
                <button className="link" onClick={() => navigate("/")}>
                  Resend OTP (30s)
                </button>
              </p>
            </div> */}
            <div className="auth_bottom">
              {countDown === 0 ? (
                <Typography
                variant="button"
                  // className="link"
                  onClick={handleResendOtp}
                >
                  Resend OTP
                </Typography>
              ) : (
                <p className="timerText">
                  OTP expires in{" "}
                  <b>00:{countDown < 10 ? `0${countDown}` : countDown}</b>
                </p>
              )}
            </div>
          </div>
          <div className="form_btn">
            <Button type="submit" className="btn btn_primary w_100">
              {isLoading ? "Verifying..." : "Submit"}
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <button className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
